import { SessionExpiredError } from "./axios-config";
/**
 * Checks if an error is a session expiration error.
 * Session expiration errors should not trigger the generic error modal
 * because the SessionExpiredModal will handle them.
 */ export function isSessionExpiredError(error) {
    return error instanceof SessionExpiredError;
}
/**
 * Checks if an error should show the generic error modal.
 * Returns false for session expiration errors.
 */ export function shouldShowErrorModal(error) {
    return !isSessionExpiredError(error);
}
